import React from "react";
import "./Loader.css";

const Loader = () => {
  return (
    <div className="loader-wrapper">

      <div className="loader-preview-bg">
        <div className="grain-overlay"></div>

        <div className="loader-wrapper">
          <div className="ring-container">
            <div className="ring-outer"></div>
            <div className="ring-track"></div>
            <div className="ring-spinner"></div>
            <div className="ring-dot"></div>
            <div className="brand-center">
              <span className="brand-monogram">D</span>
            </div>
          </div>

          <div className="loader-identity">
            <span className="loader-wordmark">Draptor</span>
            <div className="divider-line">
              <span className="divider-dot"></span>
            </div>
            <span className="loader-subtitle">Loading</span>
            <div className="progress-bar-track">
              <div className="progress-bar-fill"></div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default Loader;